import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Plan, TYPE_MARKETING } from '@bytel/bytel-sales';
import { CheckoutStorageService } from '@bytel/checkout';

import { DataCyDirective } from '@base/common/directives/data-cy.directive';

import { MainCartService } from '@services/main-cart.service';

import { FaiEligWidgetComponent, IReactWidgetFaiEligParams } from '@shared/widget/fai-elig-widget.component';

import { Subject, takeUntil } from 'rxjs';

import { SelectChoiceComponent } from '../select-choice/select-choice.component';
import { FaiService } from '@services/fai.services';

@Component({
    selector: 'checkout-fai-block',
    templateUrl: './fai-block.component.html',
    styleUrl: 'fai-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SelectChoiceComponent, DataCyDirective, FaiEligWidgetComponent],
})
export class FaiBlockComponent implements OnInit, OnDestroy {
    @Input() public cartForm: FormGroup;
    @Input() public isSubmitted: boolean;
    @Input() public isMobile: boolean;
    @Input() public focus: string;
    @Input() public redirectUrl: string;
    public shouldShowBlock: boolean = true;
    public widgetFaiEligParams: IReactWidgetFaiEligParams = {
        elig_title: 'On regarde ensemble si la Fibre est disponible chez vous ?',
        button_label: 'Tester mon éligibilité',
        endpoint: '/offres-internet/test-eligibilite-panier-mixte',
        show_migration_link: false,
        show_icon: false,
    };
    public isCompatiblePromoFoyer: boolean = true;
    protected checkoutStorage: CheckoutStorageService = inject(CheckoutStorageService);
    protected faiService: FaiService = inject(FaiService);
    private cartService: MainCartService = inject(MainCartService);
    private destroy$ = new Subject<void>();
    private _storageKey: string = 'fai';

    public onChoiceChange(value: boolean): void {
        const choiceControl = this._getChoiceControl();

        if (value) {
            this.widgetFaiEligParams.endpoint = this.redirectUrl;
            if (this.focus) {
                this.widgetFaiEligParams.focus = this.focus;
            }
            // set error to avoid form validation before quote has product
            choiceControl?.setErrors({ invalid: true });
        } else {
            choiceControl?.setErrors(null);
        }
    }
    ngOnInit(): void {
        this.isCompatiblePromoFoyer = this._getPromoFoyerEligibility();
        this.cartForm.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.shouldShowBlock = this._shouldShowFaiBlock();
        });
    }
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private _getPromoFoyerEligibility(): boolean {
        const quote = this.cartService.getQuote();
        const plan = quote.getPrincipalProduct<Plan>('Plan');

        const promoFoyerAutomatic = plan?.promotions?.automatic?.find((promotion) =>
            promotion.typesMarketing?.includes(TYPE_MARKETING.FOYER),
        );
        const promoFoyerIncitative = plan?.promotions?.incitation?.find((promotion) =>
            promotion.typesMarketing?.includes(TYPE_MARKETING.FOYER),
        );
        return !!(promoFoyerAutomatic || promoFoyerIncitative);
    }

    private _shouldShowFaiBlock(): boolean {
        const faiData = this.faiService.getFaiData();
        const isPostEligibility = !!faiData;

        if (!isPostEligibility) {
            return true;
        }

        return this.faiService.eligibility.hasFTTHEligibility;
    }

    private _getChoiceControl() {
        return this.cartForm.get('mixed-choice')?.get('choiceControl');
    }
}
